import { render } from "./EventRequestForm.vue?vue&type=template&id=5b3969ba&scoped=true"
import script from "./EventRequestForm.vue?vue&type=script&lang=js"
export * from "./EventRequestForm.vue?vue&type=script&lang=js"

import "./EventRequestForm.vue?vue&type=style&index=0&id=5b3969ba&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3969ba"]])

export default __exports__